var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChartAdd = function SvgChartAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A7AEB6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.333 9.5V14m0-4.5H3.89c-.311 0-.467 0-.586.054a.53.53 0 0 0-.242.219C3 9.88 3 10.02 3 10.3V14h3.333m0-4.5V6.8c0-.28 0-.42.06-.527a.53.53 0 0 1 .244-.218C6.755 6 6.91 6 7.222 6h1.556c.31 0 .467 0 .585.054a.53.53 0 0 1 .243.219c.06.107.06.247.06.527V8m-3.333 6h3.334m0 0H13V8.8c0-.28 0-.42-.06-.527a.53.53 0 0 0-.243-.219C12.578 8 12.422 8 12.111 8H9.667m0 6V8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7AEB6",
    fillRule: "evenodd",
    stroke: "#A7AEB6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M12 2c.11 0 .2.09.2.2v1.6h1.6a.2.2 0 1 1 0 .4h-1.6v1.6a.2.2 0 1 1-.4 0V4.2h-1.6a.2.2 0 1 1 0-.4h1.6V2.2c0-.11.09-.2.2-.2",
    clipRule: "evenodd"
  })));
};
export { SvgChartAdd as ReactComponent };
export default __webpack_public_path__ + "4f02a8b9535c5153b9ca6d1d26c177f6.svg";